import { createSelector } from '@reduxjs/toolkit';

import { useReduxSelector } from '../../../hooks';
import type { MapBounds } from '../slice';

import { mapConfigurationSelector } from './root';

export const mapInitializedSelector = createSelector(mapConfigurationSelector, state => state.initialized);
export function useMapInitializedSelector(): boolean {
  return useReduxSelector(mapInitializedSelector);
}

export const mapConfigurationBoundsSelector = createSelector(mapConfigurationSelector, state => state.bounds);
export function useMapConfigurationBoundsSelector(): MapBounds | undefined {
  return useReduxSelector(mapConfigurationBoundsSelector);
}

export const mapConfigurationCenterSelector = createSelector(
  mapConfigurationSelector,
  state => state.center as YMaps.TCoord,
);

export const mapConfigurationZoomSelector = createSelector(mapConfigurationSelector, state => state.zoom as number);

export const mapConfigurationDrawModeSelector = createSelector(mapConfigurationSelector, state => state.drawMode);
export function useMapConfigurationDrawModeSelector(): boolean {
  return useReduxSelector(mapConfigurationDrawModeSelector);
}
